import React from 'react';
import { companyInfo } from '../data/mock';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const scrollToSection = (href) => {
        const element = document.querySelector(href);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <footer className="bg-slate-900 text-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                {/* Main Footer */}
                <div className="py-16 lg:py-20">
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
                        {/* Brand */}
                        <div className="lg:col-span-2">
                            <div className="flex items-center gap-1 mb-6">
                                <span style={{ color: "#ffffff", fontWeight: 700, fontSize: "32px" }}>here</span>
                                <span style={{ color: "#007aff", fontWeight: 700, fontSize: "32px" }}>.</span>
                            </div>
                            <p className="text-slate-400 max-w-md leading-relaxed mb-6">
                                Premium nightlife essentials for bars, clubs, and festivals across Costa del Sol.
                                Fully managed, fully compliant, zero hassle.
                            </p>
                            <div className="flex items-center gap-4">
                                <a
                                    href="https://www.instagram.com/here.vending/"
                                    className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-slate-700 transition-colors"
                                    aria-label="Instagram"
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h4 className="font-semibold text-white mb-6">Quick Links</h4>
                            <ul className="space-y-4">
                                {['How it Works', 'Products', 'Locations', 'FAQ'].map((item) => (
                                    <li key={item}>

                                        <button
                                            onClick={() => scrollToSection(`#${item.toLowerCase().replace(/\s+/g, '-')}`)}
                                            className="text-slate-400 hover:text-white transition-colors"
                                        >
                                            {item}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Contact */}
                        <div>
                            <h4 className="font-semibold text-white mb-6">Contact</h4>
                            <ul className="space-y-4">
                                <li className="text-slate-400">
                                    HERE VENDING S.L.
                                </li>
                                <li>
                                    <a href={`mailto:${companyInfo.email}`} className="text-slate-400 hover:text-white transition-colors">
                                        {companyInfo.email}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://wa.me/34660007010"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-slate-400 hover:text-white transition-colors"
                                    >
                                        WhatsApp: +34 66 000 7010
                                    </a>
                                </li>
                                <li className="text-slate-400">
                                    Costa del Sol, Spain
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="py-6 border-t border-slate-800">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-slate-500 text-sm">
                            © {currentYear} here. Vending Machines. All rights reserved.
                        </p>
                        <div className="flex items-center gap-3">
                            <span className="px-3 py-1 bg-amber-500/10 text-amber-400 text-xs font-medium rounded-full">
                                18+ Only
                            </span>
                            <span className="text-slate-500 text-sm">Age verification required</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
